"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NumberCheckerGameConfigs = [
    {
        gameId: 9,
        main: {
            from: 0,
            to: 9,
            digitCount: 3
        },
        addon: undefined
    },
    {
        gameId: 10,
        main: {
            from: 1,
            to: 47,
            digitCount: 5
        },
        addon: undefined
    },
    {
        gameId: 12,
        main: {
            from: 1,
            to: 69,
            digitCount: 5
        },
        addon: {
            title: 'Power Play',
            from: 1,
            to: 26,
            digitCount: 1
        }
    },
    {
        gameId: 16,
        main: {
            from: 1,
            to: 34,
            digitCount: 5
        },
        addon: undefined
    },
    {
        gameId: 19,
        main: {
            from: 1,
            to: 70,
            digitCount: 5
        },
        addon: {
            title: 'Megaplier',
            from: 1,
            to: 25,
            digitCount: 1
        },
        paidOption: {
            title: 'Megaplier',
            isVisible: false
        },
        winningMessage: 'To calculate the total prize amount won, use the amount won and multiply by the Megaplier or Multiplier on your ticket.'
    },
    {
        gameId: 24,
        main: {
            from: 1,
            to: 52,
            digitCount: 5
        },
        addon: {
            title: 'All Star Bonus',
            from: 1,
            to: 10,
            digitCount: 1
        }
    }
];
exports.default = NumberCheckerGameConfigs;
//# sourceMappingURL=numberCheckerGameConfigs.js.map